import { gql } from 'graphql-tag';
import { FORM_DETAIL_FIELDS } from '../../Forms/gql/fragments';

// W-9 mutations (w9-plan §3.1, §6.6).

// The account's W-9 form, created live on first use (idempotent).
export const ENSURE_W9_FORM = gql`
  mutation EnsureW9Form($input: EnsureW9FormInput!) {
    ensureW9Form(input: $input) {
      ...FormDetailFields
    }
  }
  ${FORM_DETAIL_FIELDS}
`;

// The formatted full TIN ("123-45-6789"); every call is logged (T11).
export const REVEAL_FORM_SECRET = gql`
  mutation RevealFormSecret($input: RevealFormSecretInput!) {
    revealFormSecret(input: $input)
  }
`;
